import * as React from 'react';
import isEqual from 'react-fast-compare';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat } from '../../classes/seat';
import { IPriceRangeModel } from '../../filter/reducers/filter-reducers';
import isMobile from '../../helpers/is-mobile';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import SeatHover from '../components/seat-hover';
import { ISeatMapModel } from '../reducers/seatmap-reducer';
import { hoverSeatCoordinates } from '../actions/seatmap-actions';

let count = 0;

interface IMapProps {
    appSettings: IAppSettingsModel;
    seatMapModel: ISeatMapModel;
    dispatch: any;
    cartSeats: Array<CartSeat>;
    selectedPriceTypeFilter: Array<PriceType>;
    mapDragging: boolean;
}

interface IMapState {
    isChrome: boolean
}

class SvgMapHover extends React.Component<IMapProps, IMapState>{
    svgMap: any;
    transformLayer: any;

    constructor(props: IMapProps) {
        super(props);
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        this.state = {
            isChrome: isChrome
        };
    }

    private _mouseOutSeat = () => {
        this.props.dispatch(hoverSeatCoordinates(null, null, []));
    }

    shouldComponentUpdate(nextProps: IMapProps, nextState: IMapState) {
        return !nextProps.mapDragging &&
            this.props.selectedPriceTypeFilter.length !== nextProps.selectedPriceTypeFilter.length
            || this.props.cartSeats.length !== nextProps.cartSeats.length
            || (this.props.seatMapModel.seatsHovered.length == 0 || nextProps.seatMapModel.seatsHovered.length == 0 ? true
                : this.props.seatMapModel.seatsHovered[0].seatId !== nextProps.seatMapModel.seatsHovered[0].seatId)
            || !isEqual(this.props, nextProps);
    }

    render() {
        const seats = this.props.seatMapModel.seatsHovered;
        const seatSection = (seats.length > 0 ? this.props.appSettings.useZoneDescription && seats[0].zoneDescription !== null ? seats[0].zoneDescription : seats[0].tessituraSeat.sectionDescription : '').replace(/\s/g, '');
        const seatInfo = (seats.length > 1 ? this.props.appSettings.groupSeatCartItemText.replace("{0}", "").replace("{1}", seatSection) : `${seats[0].tessituraSeat.rowText}-${seats[0].tessituraSeat.numberText}`).replace(/\s/g, '');
        const ariaLabelId = `${seatSection}_${seatInfo}`;
        return (
            <svg className="hover-map-svg" viewBox="0 0 260 220" aria-labelledby={ariaLabelId}>
                <g>
                    {
                        !this.props.appSettings.disableSeatHover && !isMobile() ?
                            <SeatHover
                                ariaLabelId={ariaLabelId}
                                mouseOutHover={this._mouseOutSeat.bind(this)}
                                isChrome={this.state.isChrome}
                                showHover={!this.props.mapDragging && this.props.seatMapModel.seatHoverX !== null && this.props.seatMapModel.seatHoverY !== null}
                                xPosition={this.props.seatMapModel.seatHoverX} yPosition={this.props.seatMapModel.seatHoverY} appSettingsModel={this.props.appSettings} levelPricing={this.props.seatMapModel.allSeatPricing}
                                selectedPriceTypes={this.props.selectedPriceTypeFilter} cartSeats={this.props.cartSeats} seats={this.props.seatMapModel.seatsHovered} dispatch={this.props.dispatch} />
                            : null
                    }
                </g>

            </svg>
        );
    }


}

export default SvgMapHover;